
export let template1 = `<table style='width:100%'>
  <tr align='{{align}}'>
    <td>{{text1}}</td>
  </tr>
</table>`;

export let template2 = `<table style='width:100%'>
    <tr align='{{align}}'>
        <td style='width:50%'>
            {{text1}}
        </td>
        <td style='width:50%'>
            {{text2}}
        </td>
    </tr>
</table>`;
export let template3 = `<table style='width:100%'>
	<tr align='{{align}}'>
		<td style='width:33%'>{{text1}}</td>
		<td style='width:33%'>{{text2}}</td>
		<td style='width:33%'>{{text3}}</td>
	</tr>
</table>`;
export let template4 = `<table style='width:100%'>
	<tr align='{{align}}'>
		<td>
			<h1>{{title}}</h1>
		</td>
	</tr>
</table>`;
export let template5 = `<table style='width:100%'>
	<tr align='{{align}}'>
		<td>
			<h3>{{title}}</h3>
		</td>
	</tr>
</table>`;
export let template6 = `<table style='width:100%'>
	<tr align='{{align}}'>
		<td style='width:100%'><img src='{{img}}' width='{{imgSize}}'></td>
	</tr>
</table>`;
export let template7 = `<table style='width:100%'>
	<tr align='{{align}}'>
		<td style='width:50%'><img src='{{img1}}' width='{{img1Size}}'></td>
		<td style='width:50%'><img src='{{img2}}' width='{{img2Size}}'></td>
	</tr>
</table>`;
export let template8 = `<table style='width:100%'>
	<tr align='{{align}}'>
		<td style='width:50%'>
			<p>{{text}}</p>
		</td>
		<td style='width:50%'><img src='{{img}}' width='{{imgSize}}'></td>
	</tr>
</table>`;
export let template9 = `<table style='width:100%'>
	<tr align='{{align}}'>
		<td style='width:50%'><img src='{{img}}' width='{{imgSize}}'></td>
		<td style='width:50%'>
			<p>{{text}}</p>
		</td>
	</tr>
</table>`;
export let template10 = `<table style='width:100%'>
	<tr>
		<td>
			<div style='border-bottom:{{color}} 1px solid'></div>
		</td>
	</tr>
</table>`;
export let template11 = `<table style='width:100%'>
	<tr>
		<td>
			<div style='border-bottom:{{color}} 1px dashed'></div>
		</td>
	</tr>
</table>`;
export let template12 = `<table style='width:100%'>
	<tr align='{{align}}'>
		<td>
			<a href='{{href}}' target="_blank">{{linkText}}</a>
		</td>
	</tr>
</table>`;

export let template13 = `<table style='width:100%'>
	<tr align='{{align}}'>
		<td style='width:50%'>
			<a href='{{href1}}' target="_blank">{{linkText1}}</a>
		</td>
		<td style='width:50%'>
			<a href='{{href2}}' target="_blank">{{linkText2}}</a>
		</td>
	</tr>
</table>`;
export let template14 = `<table style='width:100%'>
	<tr align='{{align}}'>
		<td>
			<a href='{{href}}' style='color: white; background-color: {{bgColor1}}; padding: 10px; border-radius: 3px; 
			font-family: Helvetica; font-size: 15px; line-height: 20.8px; word-wrap: break-word; font-weight: normal; 
			text-decoration: none;' target="_blank">{{linkText}}</a>
		</td>
	</tr>
</table>`;
export let template15 = `<table style='width:100%'>
	<tr align='{{align}}'>
		<td style='width:50%'>
			<a href='{{href1}}' style='color: white; background-color: {{bgColor1}}; padding: 10px; border-radius: 3px; 
			font-family: Helvetica; font-size: 15px; line-height: 20.8px; word-wrap: break-word; font-weight: normal; 
			text-decoration: none;' target="_blank">{{linkText1}}</a>
		</td>
		<td style='width:50%'>
			<a href='{{href2}}' style='color: white; background-color: {{bgColor2}}; padding: 10px; border-radius: 3px; 
			font-family: Helvetica; font-size: 15px; line-height: 20.8px; word-wrap: break-word; font-weight: normal; 
			text-decoration: none;' target="_blank">{{linkText2}}</a>
		</td>
	</tr>
</table>`;
export let template16 = `<table style='width:100%'>
	<tr>
		<td>
			<div style='height:{{height}}'></div>
		</td>
	</tr>
</table>`;
